import React from "react";
import "../styles/loading/loading.css"; // We'll add styles in the next step
import { useTranslation } from "react-i18next";

const Loading = () => {
    const { t } = useTranslation();
    return (
        <div className="loading-container">
            <div className="loading-text">
                {t('loading-page')}
                <span ></span>
                <span></span>
                <span></span>
            </div>
        </div >


    );
};

export default Loading;
